<script>
import AdaptsRelateFieldtype from './AdaptsRelateFieldtype.vue';

export default {

    mixins: [AdaptsRelateFieldtype]

};
</script>



// WEBPACK FOOTER //
// CollectionsFieldtype.vue?123b1449